<template>
<!--  todo change issue_date to pcr_swab_date to pcr_result_date when uploading pcr files  -->
    <div class="container-fluid py-3">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header text-left">
                        <div class="font-weight-bold">
                            <div class="custom-header"> Crew Endorsement / Reservation</div>
                        </div>
                    </div>

                    <div class="card-body card-wrap custom-text mt-3">
                        <div class="row">
                            <div class="col-md-6">

                                <div class="form-group row text-right">
                                    <label for="checkIn" class="col-sm-3 col-form-label font-weight-bold">
                                        Check In <small class="tnkc-danger-text h6">*</small>:
                                    </label>
                                    <div class="col-sm-5">
                                        <input type="date"
                                               class="form-control form-control-sm"
                                               id="checkIn"
                                               v-model="newBatch.dateCheckIn"
                                               v-on:input="getCurrentRoomCount"
                                               :disabled="this.newBatch.crewEndorseList.length == 0 ? false : true ">
                                    </div>
                                </div>

                                <div class="form-group row text-right">
                                    <label for="checkOut" class="col-sm-3 col-form-label font-weight-bold">
                                        Check Out <small class="tnkc-danger-text h6">*</small>:
                                    </label>
                                    <div class="col-sm-5">
                                        <input type="date"
                                               class="form-control form-control-sm"
                                               id="checkOut" v-model="newBatch.dateCheckOut"
                                               v-on:input="getCurrentRoomCount"
                                               :disabled="this.newBatch.crewEndorseList.length == 0 ? false : true ">
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="numOfCrew" class="col-sm-3 col-form-label font-weight-bold text-right">
                                        # Of Crew <small class="tnkc-danger-text h6">*</small>:
                                    </label>

                                    <div class="col-sm-2">
                                        <select class="custom-select form-control-sm text-center" id="numOfCrew" v-model="newBatch.num_crew" v-on:change="setCrewNum" :disabled="this.newBatch.crewEndorseList.length == 0 ? false : true " >
                                            <option selected :value="null">--</option>
                                            <option v-for="n in getNumOfCrews()" :value="n">{{n}}</option>
                                        </select>
                                    </div>

                                    <div class="col-sm-4 row">
                                        <!-- Button trigger modal -->
                                        <button type="button" class="btn tnkc-primary"data-toggle="modal" data-target="#selecCrew"  data-backdrop="static" data-keyboard="false" :disabled="isEmpty(newBatch.num_crew)">
                                           Select Crew
                                        </button>
                                    </div>

                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label for="numOfCrew" class="col-sm-2 col-form-label font-weight-bold text-left">TNKC :</label>
                                    <div class="col-sm-2 mr-3 p-00">
                                        <input class="form-control-plaintext text-left  border-bottom" placeholder="-----" v-model="tnkcRoomsCount"/>
                                    </div>

                                    <label for="numOfCrew" class="col-sm-3 col-form-label font-weight-bold text-left">ZENROOM :</label>
                                    <div class="col-sm-2 p-0">
                                        <input type="text" class="form-control-plaintext text-left border-bottom" placeholder="-----" v-model="zenRoomsCount"/>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <p class="text-left text-warning small font-weight-bold col-sm-6">
                                        <span class="tnkc-danger-text">*</span>This is only guide for the available rooms
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row ">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-header p-1">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="row">
                                                    <div class="col-md-5 pt-1">
                                                        <!-- modified batch number -->
                                                        <span class="font-weight-bold">Batch No: <small class="ml-2">{{batchControlNum}}</small> </span>
                                                    </div>

                                                    <div class="col-md-3 p-0">
                                                        <select class="form-control form-control-xsm custom-select" id="intendVessel" v-model="newBatch.intended_vessel" v-on:change="setKeyVessel">
                                                            <option class="custom-select" :value="null">-Intended Vessel-</option>
                                                            <option class="custom-text custom-select" v-for="vessel in vessels" :key="vessel.id" :value="vessel.id">
                                                                {{titleCase(vessel.name)}}
                                                            </option>
                                                        </select>
                                                    </div>

                                                    <div class="col-md-4" v-if="newBatch.crewEndorseList != 0">
                                                        <button type="button" class="btn btn-sm btn-endorse-crew mr-1 px-5" @click="create_new_endorsement_batch">
                                                            <font-awesome-icon class="mr-1" icon="bookmark"/>
                                                            Endorse Crews
                                                        </button>

                                                        <button type="button" class="btn btn-sm tnkc-danger" @click="set_batch_null">
                                                            <font-awesome-icon icon="undo"/>
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card-body">
                                        <div class="table-responsive table-wrap">

                                            <table class="table table-bordered custom-text">
                                                <thead>
                                                    <tr>
                                                        <th scope="col" class="p-1" width="1">#</th>
                                                        <th scope="col" class="p-1" width="100">Rank</th>
                                                        <th scope="col" class="p-1" width="200">Crew Name</th>
                                                        <th scope="col" class="p-1">w/PCR</th>
                                                        <th scope="col" class="p-1">Check In</th>
                                                        <th scope="col" class="p-1">Check Out</th>
                                                        <th scope="col" width="200" class="p-1 ml-5">Action</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr v-for="(crewEndorse,index) in newBatch.crewEndorseList" :key="JSON.stringify(crewEndorse)">
                                                        <th scope="row">{{index+1}}</th>
                                                        <td>{{crewEndorse.crew.rank_alias2}}</td>
                                                        <td class="pl-3  text-left">{{titleCase(crewEndorse.crew.fullName)}}</td>
                                                        <td>
                                                            <input class="custom-checkbox p-1" type="checkbox" id="hasFile" :checked="hasFileCPR(crewEndorse.file)" disabled/>
                                                        </td>
                                                        <td>{{newBatch.dateCheckIn | moment('D, MMM YYYY')}}</td>
                                                        <td>{{newBatch.dateCheckOut | moment('D, MMM YYYY')}}</td>
                                                        <td class="p-1">
                                                            <div class="p-1">
                                                                <button type="button" class="btn btn-sm tnkc-warning mr-1" @click="edit_edorsement(index)" data-toggle="modal" data-target="#crewEndorsed"  data-backdrop="static" data-keyboard="false">
                                                                    <font-awesome-icon icon="edit"/>
                                                                    Edit
                                                                </button>
                                                                <button type="button" class="btn btn-sm tnkc-danger" @click="delete_crew_endorsement(index)">
                                                                    <font-awesome-icon icon="times"/>
                                                                    Remove
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- New Endorsement   Modal -->
        <div class="modal fade" id="selecCrew" tabindex="-1" role="dialog" aria-labelledby="selecCrewTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="selecCrewTitle">Endorse dates [ <span class="font-weight-bold">{{newBatch.dateCheckIn | moment('D, MMM YYYY')}}</span> - <span class="font-weight-bold">{{newBatch.dateCheckOut | moment('D, MMM YYYY')}}</span> ]</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                          <div class="col-md-6 text-left border-right">
                              <div class="form-group">
                                  <label for="crewList" class="font-weight-bold custom-label"><small class="tnkc-danger-text h6">*</small>Name :</label>
                                  <multiSelect v-model="value" :options="crewKeyDetails" :custom-label="nameWithRank"
                                               placeholder="Search Crew to Endorse"
                                               label="fullName"
                                               track-by="id"
                                               :optionsLimi="1000"
                                               id="crewList"
                                               @input="demoConsole"
                                               class="form-control-sm">
                                  </multiSelect>
                              </div>

                              <div class="form-group">
                                  <label for="purposesDiv" class="custom-label font-weight-bold mt-1"><small class="tnkc-danger-text h6">*</small>Purposes :</label>
                                  <div class="col-sm-9 text-left ml-4" id="purposesDiv">
                                      <div class="form-check mt-2" v-for="purpose in purposes" :key="purposes.id">
                                          <input class="form-check-input" type="checkbox" :id="'purpose'+purpose.id" :value="purpose.id" v-model="newCrewEndorse.purposes" @click="getCheckedPurposed($event)">
                                          <label class="form-check-label ml-3 custom-text" :for="'purpose'+purpose.id">{{titleCase(purpose.description)}}</label>
                                      </div>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <label for="remarks" class="font-weight-bold custom-label mt-4"><small class="tnkc-danger-text h6">*</small>Remarks :</label>
                                  <input readonly type="text" id="countdown1" size="3" value="200" class="ml-3 text-muted border-0"><span class="text-muted">Characters Left</span>
                                  <textarea class="form-control" id="remarks" rows="3" v-model="newCrewEndorse.remarks" @keydown="limiteTextRemarks('remarks','countdown1',200)"></textarea>
                              </div>
                          </div>
                          <div class="col-md-6 text-left">
                              <!-- todo fetch if the user has existing cpr file. -->
                             <!-- <div class="form-group">
                                  <label for="pcr" class="font-weight-bold custom-label ">Has existing PCR :</label>
                                  <div class="row ml-1">
                                      <button class="btn btn-sm tnkc-primary ml-3" id="pcr">
                                          <font-awesome-icon icon="file"/>
                                          view file
                                      </button>

                                      <button class="btn btn-sm btn-light ml-3" id="uploadAddPcr">
                                          <font-awesome-icon icon="file-upload"/>
                                          add file
                                      </button>
                                  </div>
                              </div>-->

                              <div class="form-group mt-1">
                                  <label for="pcrFile" class="font-weight-bold custom-label mt-4"><small class="tnkc-danger-text h6">*</small>PCR :</label>
                                  <input type="file" class="form-control-file w-50 border rounded p-1 w-75" id="pcrFile" @change="getAttachedFile">
                              </div>

<!--                              <div class="form-group mt-1" v-if="!isEmpty(newCrewEndorse.file)">-->
<!--                                  <label for="pcrIssueDate" class="font-weight-bold custom-label mt-4"><small class="tnkc-danger-text h6">*</small>PCR Issued Date :</label>-->
<!--                                  <input type="date" class="form-control w-75" id="pcrIssueDate" v-model="newCrewEndorse.pcr_issued_date">-->
<!--                              </div>-->
                              <div class="form-group mt-1" v-if="!isEmpty(newCrewEndorse.file)">
                                <label for="pcr_swab_date" class="font-weight-bold custom-label mt-4"><small class="tnkc-danger-text h6">*</small>Swab Date :</label>
                                <input type="date" class="form-control w-75" id="pcr_swab_date" v-model="newCrewEndorse.pcr_swab_date">
                              </div>
                              <div class="form-group mt-1" v-if="!isEmpty(newCrewEndorse.file)">
                                <label for="pcr_result_date" class="font-weight-bold custom-label mt-4"><small class="tnkc-danger-text h6">*</small>Result Date :</label>
                                <input type="date" class="form-control w-75" id="pcr_result_date" v-model="newCrewEndorse.pcr_result_date">
                              </div>
                          </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn tnkc-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn tnkc-primary" @click="add_on_batch">Save changes</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Crew Endorsement   Modal -->
        <div class="modal fade" id="crewEndorsed" tabindex="-1" role="dialog" aria-labelledby="crewEndorsedTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title font-weight-bold" id="crewEndorsedTitle">{{crewEndorse.crew ? crewEndorse.crew.fullName : ''}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6 text-left border-right">

                                <div class="form-group">
                                    <label for="purposesDiv" class="custom-label font-weight-bold mt-1"><small class="tnkc-danger-text h6">*</small>Purposes :</label>
                                    <div class="col-sm-9 text-left ml-4">
                                        <div class="form-check mt-2" v-for="purpose in purposes" :key="purposes.id">
                                            <input class="form-check-input" type="checkbox" :id="'purpose'+purpose.id" :value="purpose.id" v-model="crewEndorse.purposes" @click="getCheckedPurposed($event)">
                                            <label class="form-check-label ml-3 custom-text" :for="'purpose'+purpose.id">{{titleCase(purpose.description)}}</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="endorsedRemarks" class="font-weight-bold custom-label mt-4"><small class="tnkc-danger-text h6">*</small>Remarks :</label>
                                    <input readonly type="text" id="countdown2" size="3" value="200" class="ml-3 text-muted border-0"><span class="text-muted">Characters Left</span>
                                    <textarea class="form-control" id="endorsedRemarks" rows="3" v-model="crewEndorse.remarks" @keydown="limiteTextRemarks('endorsedRemarks','countdown2',200)"></textarea>
                                </div>
                            </div>

                            <div class="col-md-6 text-left">
                                <div class="form-group">
                                    <label class="font-weight-bold custom-label">Attached PCR :</label>
                                    <div class="row ml-1">
                                        <button class="btn btn-sm tnkc-primary ml-3" @click="viewPdfFile(crewEndorse.file)" v-if="!isEmpty(crewEndorse.file)">
                                            <font-awesome-icon icon="paperclip"/>
                                            pcr
                                        </button>

                                        <button class="btn btn-sm btn-light ml-3" @click="replaceFile= !replaceFile">
                                            <font-awesome-icon icon="file-upload"/>
                                            <span v-if="!isEmpty(crewEndorse.file)">{{replaceFile ? 'cancel' : 'replace file'}}</span>
                                            <span v-else>{{ replaceFile ? 'cancel' : 'attach pcr file'}}</span>

                                        </button>
                                    </div>
                                </div>

                                <div class="form-group mt-1" v-if="replaceFile == true">
                                    <label for="pcrFile" class="font-weight-bold custom-label mt-4 "><small class="tnkc-danger-text h6">*</small>PCR :</label>
                                    <input type="file" class="form-control-file w-50 border rounded p-1 w-75" id="epcrFile" @change="getAttachedReplace">
                                </div>

<!--                                <div class="form-group mt-1" v-if="!isEmpty(crewEndorse.file)">-->
<!--                                    <label for="epcrIssuedDate" class="font-weight-bold custom-label mt-4"><small class="tnkc-danger-text h6">*</small>PCR Issued Date :</label>-->
<!--                                    <input type="date" class="form-control w-50 ml-3" id="epcrIssuedDate" v-model="crewEndorse.pcr_issued_date">-->
<!--                                </div>-->
                                <div class="form-group mt-1" v-if="!isEmpty(newCrewEndorse.file)">
                                  <label for="epcr_swab_date" class="font-weight-bold custom-label mt-4"><small class="tnkc-danger-text h6">*</small>Swab Date :</label>
                                  <input type="date" class="form-control w-75" id="epcr_swab_date" v-model="newCrewEndorse.pcr_swab_date">
                                </div>
                                <div class="form-group mt-1" v-if="!isEmpty(newCrewEndorse.file)">
                                  <label for="epcr_result_date" class="font-weight-bold custom-label mt-4"><small class="tnkc-danger-text h6">*</small>Result Date :</label>
                                  <input type="date" class="form-control w-75" id="epcr_result_date" v-model="newCrewEndorse.pcr_result_date">
                                </div>
                              </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn tnkc-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn tnkc-primary"  @click="update_endorsement">Save changes</button>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import MultiSelect from 'vue-multiselect';
  import {mapGetters, mapActions} from 'vuex';
  import {appMixins} from '../../mixins/app.mixins';
  import {GlobalUtility} from '../../service/global-utility.service';

  export default {
    name: 'CrewEndorse',
    mixins: [appMixins],
    data() {
      return {
        tnkcRmCount: 0,
        zenRmCount: 0,
        checkInDate: '',
        checkOutDate: '',
        withPCR: false,
        value: {fullName: '', rank_alias2: ''},

        //dump file
        file: null,

        replaceFile : false,
      };
    },

    components: {
      MultiSelect,
    },

    methods: {

      ...mapActions([
        'getPurposeList', 'getVessels', 'getCrewKeyDetails', 'createNewEndorsementBatch', 'addCrewEndorseMent',
        'getBatchControllNo', 'setNewEndorsementNull', 'setNewBatchNull','deleteCrewEndorseMent','editViewEndorseMent',
        'updateCrewEndorseMent','setNewBatchNull','getCountRoomsAvailable'
      ]),

      demoConsole(){
        // console.log(this.value);
      },

      checkRoomCountIn() {
        this.tnkcRmCount = 14;
        this.zenRmCount = 20;
        this.checkInDate = document.getElementById('checkIn').value;
      },

      checkRoomCountOut() {
        this.tnkcRmCount = 10;
        this.zenRmCount = 15;
        this.checkOutDate = document.getElementById('checkOut').value;
      },

      nameWithRank({fullName, rank_alias2}) {
        return `[ ${rank_alias2 ? rank_alias2.toUpperCase() : ''} ] - ${fullName}`;
      },

      getNumOfCrews() {
        const tnkc = this.tnkcRoomsCount ? this.tnkcRoomsCount : 1;
        const zenroom = this.zenRoomsCount ? this.zenRoomsCount : 1;
        let start = 1;
        const stop = tnkc + zenroom;

        return new Array(stop - start).fill(start).map((n, i) => n + i);
      },

      getCheckedPurposed(e) {
        if (e.target.checked) {
          //test for fetching the id value of purpose check.
          // console.log(this.checkedPurposed.sort());
        }
      },

      async loadingScreenOnFirstRun() {
        //upon first running of vuex,
        if (this.crewKeyDetails == '' || this.crewKeyDetails == null || this.crewKeyDetails == undefined) {
          await this.loadingAlert('Please wait.. Loading crew list for searching');
        }
      },

      //set intended vessel
      setKeyVessel(e) {
        this.newBatch.intended_vessel = e.target.value;
      },

      setCrewNum(e){
        this.newBatch.num_crew = e.target.value;
      },

      //replace file on crew endorsed.
      getAttachedReplace(e){
        const selectedFile = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
          this.crewEndorse.file = e.target.result;
        };
        reader.readAsDataURL(selectedFile);
      },

      //attached file on new crew endorse
      getAttachedFile(e) {
        const selectedFile = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
          this.newCrewEndorse.file = e.target.result;
        };
        reader.readAsDataURL(selectedFile);
      },

      hasFileCPR(obj) {
        if (Object.keys(obj).length != 0) {
          return true;
        } else {
          return false;
        }
      },

      setInputFileNull(html_tag_id) {
        return document.getElementById(`${html_tag_id}`).value = null;
      },

      setValueNull() {
        return this.value = {
          fullName: '',
          rank_alias2: '',
          id: '',
        };
      },

      isEmpty(obj) {
        for(let key in obj) {
          if(obj.hasOwnProperty(key) && obj[key].length != 0 && obj[key] != '' && obj[key] != null)
            return false;
        }
        return true;
      },

      add_on_batch() {
        this.newCrewEndorse.crew = this.value;   //load crew select

        let startDate = Date.parse(this.newBatch.dateCheckIn);
        let endDate = Date.parse(this.newBatch.dateCheckOut);

        if(this.isEmpty(this.newCrewEndorse.crew) || this.isEmpty(this.newCrewEndorse.purposes)
            || this.isEmpty(this.newCrewEndorse.remarks) || this.isEmpty(this.newBatch.num_crew)){
          this.warningAlert('All fields with ( * ) must have value.');

        }else if(!this.isEmpty(this.newBatch.num_crew) && this.newBatch.num_crew <= this.newBatch.crewEndorseList.length){
          this.warningAlert('Batch number of crew endorsed is full.');
          this.setNewEndorsementNull();
          this.setValueNull();

        }else if(!this.isEmpty(this.newCrewEndorse.file) && this.isEmpty(this.newCrewEndorse.pcr_swab_date)){
          this.warningAlert('PCR Swab Date should have value');

        }else if(!this.isEmpty(this.newCrewEndorse.file) && this.isEmpty(this.newCrewEndorse.pcr_result_date)){
          this.warningAlert('PCR Result Date should have value');

        }else if(startDate > endDate) {
          this.warningAlert('The check-out date must come after the check-in date');

        }else{
          this.addEndorsement();

        }
      },

      addEndorsement(){
        this.addCrewEndorseMent(this.newCrewEndorse).then((res) => {

          if (res == true) {

            this.setNewEndorsementNull();
            this.setInputFileNull('pcrFile'); //get input file html id,
            this.setValueNull();
            this.successAlert('Add Successfully.');

          } else if (res == false) {

            this.setNewEndorsementNull();
            this.setInputFileNull('pcrFile');
            this.setValueNull();
            this.warningAlert('Record exist for batch endorsement.');

          }
        });
      },

      edit_edorsement(id){
        console.log('blob');
        this.editViewEndorseMent(id);
      },

     async update_endorsement(){
        let msg = 'Are you sure you want to update the endorse details';
        let actionType = '';
        if(await this.questionAlert(msg,actionType)){
          this.updateCrewEndorseMent(this.crewEndorse).then((res)=>{
            if(res == true){
              this.successAlert('Update Successfully');
            }
          });
        }
      },

      delete_crew_endorsement(id){
        this.deleteCrewEndorseMent(id);
      },

      //todo import module method for crew endorsements
      create_new_endorsement_batch() {
        // const formData = new FormData();
        this.newBatch.batch_no = this.batchControlNum;
        this.createNewEndorsementBatch(this.newBatch).then((res)=>{
          if(res == true){
            this.getCrewKeyDetails();
            this.getBatchControllNo();
            this.setNewBatchNull();
            this.setInputFileNull('pcrFile');
            this.successAlert('Successfully Endorse.');
          }
        });
      },

      set_batch_null(){
        this.setNewBatchNull();
      },

     getCurrentRoomCount(){
        let startDate = Date.parse(this.newBatch.dateCheckIn);
        let endDate = Date.parse(this.newBatch.dateCheckOut);

        const params = {
          dateFrom : this.newBatch.dateCheckIn,
          dateTo : this.newBatch.dateCheckOut,
        }

        // if(startDate > endDate) {
        //   this.warningAlert('The check-out date must come after the check-in date');
        // }

        this.getCountRoomsAvailable(params);
      }
    },

    computed: {
      ...mapGetters([
        'purposes',
        'crewEndorseList',
        'crewEndorse',
        'vessels',
        'newCrewEndorse',
        'crewKeyDetails',
        'newBatch',
        'batchControlNum',
        'crewEndorse',
        'tnkcRoomsCount',
        'zenRoomsCount'
      ]),
    },

   async created() {
      this.getPurposeList();
      this.getVessels();
      this.getCrewKeyDetails();
     await this.loadingScreenOnFirstRun();
     await this.getBatchControllNo();
      // this.getCountRoomsAvailable();
      this.limiteTextRemarks('remarks','countdown1',200);
    },

    mounted() {
      //todo
      console.log(this.tnkcRoomsCount);
    },

    destroyed() {
      this.setNewBatchNull();
    }

  };
</script>

<style scoped>
    .hr-w-5 {
        margin-top: 1rem;
        margin-bottom: 1rem;
        border-top: 3px solid rgba(0, 0, 0, .1)
    }

    #batchTable td {
        vertical-align: middle;
    }

    .action-col-batch {
        width: 160px;
    }

    .table-wrap {
        height: 280px !important;
        overflow-y: auto;
        font-size: 14px !important;
    }

    .card-wrap {
        padding: 0 !important;
    }

    .btn-xsm, .btn-group-xsm > .btn {
        padding: 0.20rem 0.2rem;
        font-size: 0.870rem;
        line-height: 1.3;
        border-radius: 0.25rem;
    }

    .multiselect {
        height: calc(1em + 0.3rem + 1px) !important;
        padding: 0.2rem 0.3rem;
        font-size: 0.870rem;
        line-height: 1;
        border-radius: 0.1rem;
    }

    textarea {
        /*width: 200px;*/
        min-width: 80%;
        min-width: 100%;
        max-width: 400px;

        height: 200px;
        min-height: 80px;
        max-height: 80px;
    }

    input[type=checkbox] {
        transform: scale(2);
    }

    .form-control-xsm {
      height: calc(1.5em + 0.5rem + 2px);
      padding: 0.25rem 0.5rem;
      font-size: 0.875rem;
      line-height: 1.5;
      border-radius: 0.2rem;
    }

</style>


<style>

    .w-15{
        width: 15% !important;
    }

    .multiselect__select {
        position: absolute;
        width: 40px !important;
        height: 40px !important;
        right: 5px !important;
        top: 2px !important;
        padding: 2px 4px !important;
        text-align: center;
        transition: transform .2s ease;
        background-color: #cccccc !important;
    }

    @media (min-width: 992px) {
        .modal-lg,
        .modal-xl {
            max-width: 900px !important;
        }
    }

    button.btn-endorse-crew,
    a.btn-endorse-crew {
      background-color: #7ef0da;
      color: #4a4f54;
    }
    a.btn-endorse-crew:hover,
    a.btn-endorse-crew:focus,
    button.btn-endorse-crew:hover,
    button.btn-endorse-crew:focus {
      background-color: #32e7c4 !important;
      color: #4a4f54;
    }
</style>
